module.exports = __webpack_public_path__ + "static/media/ehealth-bg1-4-3.af7ee74e.jpg";